import client from '@/lib/feathers';

const getHouseHoldNumber = async () => {
  const result: string[] = [];

  try {
    const { data } = await client.service('residentAccountNumbers').find({
      query: {
        $select: ['householdNumber'],
      },
    });
    result.push(
      ...data.map(
        (item: { _id: string; householdNumber: string }) => item.householdNumber
      )
    );
  } catch (err) {
    console.error(err);
  }

  return result;
};

const formatNumberWithComma = (stringifiedNumber: string) => {
  const pattern = /\B(?=(\d{3})+(?!\d))/g;
  const result = stringifiedNumber.replace(pattern, ',');
  return result;
};

export { getHouseHoldNumber, formatNumberWithComma };
